// Wallet page logic
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// Market prices cache
let marketPrices = {
  'BTC-USDT': 0,
  'ETH-USDT': 0
};

document.addEventListener('DOMContentLoaded', async () => {
  // Load prices first, then wallets
  await loadMarketPrices();
  await loadWallets();
  loadTradeHistory();
  
  // Refresh prices every 30 seconds
  setInterval(async () => {
    await loadMarketPrices();
    await loadWallets();
  }, 30000);
});

// History view switching
window.switchHistoryView = function() {
  const historyType = document.getElementById('historyType').value;
  document.getElementById('tradesHistory').classList.toggle('hidden', historyType !== 'trades');
  document.getElementById('depositsHistory').classList.toggle('hidden', historyType !== 'deposits');
  document.getElementById('withdrawalsHistory').classList.toggle('hidden', historyType !== 'withdrawals');
  
  if (historyType === 'deposits') {
    loadDepositHistory();
  } else if (historyType === 'withdrawals') {
    loadWithdrawalHistory();
  }
};

window.refreshCurrentHistory = function() {
  const historyType = document.getElementById('historyType').value;
  if (historyType === 'trades') {
    loadTradeHistory();
  } else if (historyType === 'deposits') {
    loadDepositHistory();
  } else if (historyType === 'withdrawals') {
    loadWithdrawalHistory();
  }
};

async function loadMarketPrices() {
  try {
    const response = await fetch(`${API_URL}/api/v1/markets`);
    if (!response.ok) {
      console.error('Failed to fetch market prices, status:', response.status);
      return;
    }
    
    const data = await response.json();
    if (data.markets && data.markets.length > 0) {
      data.markets.forEach(market => {
        const price = parseFloat(market.last_price || market.lastPrice || 0);
        marketPrices[market.symbol] = price;
        console.log(`Market price loaded: ${market.symbol} = ${price}`);
      });
      console.log('All market prices loaded:', marketPrices);
    }
  } catch (error) {
    console.error('Failed to load market prices:', error);
  }
}

async function loadWallets() {
  try {
    const token = localStorage.getItem('token') || localStorage.getItem('authToken');
    if (!token) {
      window.location.href = '/login.html?redirect=/wallet.html';
      return;
    }

    console.log('=== WALLET TABLE FETCH ===');
    console.log('Token:', token?.substring(0, 20) + '...');
    console.log('URL:', `${API_URL}/api/v1/wallets`);

    const response = await fetch(`${API_URL}/api/v1/wallets`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    console.log('Response status:', response.status);

    if (response.status === 401 || response.status === 404) {
      // Token invalid or user not found, redirect to login
      localStorage.removeItem('token');
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      window.location.href = '/login.html?redirect=/wallet.html';
      return;
    }

    if (!response.ok) {
      throw new Error('Failed to load wallets');
    }

    const data = await response.json();
    console.log('ALL wallet data from table:', data);
    console.log('Wallets array:', data.wallets);
    console.log('Number of wallets:', data.wallets?.length || 0);
    console.log('=== END WALLET TABLE FETCH ===');
    
    if (data.wallets && data.wallets.length > 0) {
      console.log('Calling renderWallets with', data.wallets.length, 'wallets');
      renderWallets(data.wallets);
    } else {
      console.warn('No wallets found, rendering with empty array');
      renderWallets([]);
    }
  } catch (error) {
    console.error('Load wallets error:', error);
    renderWallets([]);
  }
}

function calculateUSDValue(currency, balance) {
  const amount = parseFloat(balance);
  if (amount === 0) return 0;
  
  switch(currency) {
    case 'USDT':
      return amount;
    case 'BTC':
      return amount * marketPrices['BTC-USDT'];
    case 'ETH':
      return amount * marketPrices['ETH-USDT'];
    default:
      return 0;
  }
}

function renderWallets(wallets) {
  console.log('=== RENDER WALLETS CALLED ===');
  console.log('Received wallets:', wallets);
  console.log('Market prices at render time:', marketPrices);
  
  const container = document.getElementById('assetsList');
  const mobileContainer = document.getElementById('assetsListMobile');
  
  if (!container) {
    console.error('❌ Assets list container not found!');
    return;
  }

  // Calculate total balance in USD (available + locked) for all wallets
  let totalUSD = 0;
  
  if (wallets && wallets.length > 0) {
    console.log(`Processing ${wallets.length} wallets for balance calculation...`);
    wallets.forEach(wallet => {
      const balance = parseFloat(wallet.balance) || 0;
      const locked = parseFloat(wallet.lockedBalance || wallet.locked_balance) || 0;
      const total = balance + locked;
      const usdValue = calculateUSDValue(wallet.currency, total);
      console.log(`  ${wallet.currency}: balance=${balance}, locked=${locked}, total=${total}, usdValue=${usdValue}`);
      totalUSD += usdValue;
    });
  } else {
    console.warn('⚠️ No wallets to process');
  }

  console.log(`📊 TOTAL USD BALANCE: $${totalUSD.toFixed(2)}`);

  // Calculate BTC equivalent
  const btcPrice = marketPrices['BTC-USDT'];
  const btcEquivalent = btcPrice > 0 ? totalUSD / btcPrice : 0;
  
  console.log(`💰 BTC price: $${btcPrice}, BTC equivalent: ${btcEquivalent.toFixed(8)}`);

  // Update total balance display - ALWAYS update, even if 0
  const totalBalanceDiv = document.getElementById('totalBalanceAmount');
  const btcEquivDiv = document.getElementById('totalBalanceBTC');
  
  console.log('Looking for element with ID: totalBalanceAmount');
  console.log('Found element:', totalBalanceDiv);
  console.log('Looking for element with ID: totalBalanceBTC');
  console.log('Found element:', btcEquivDiv);
  
  if (totalBalanceDiv) {
    const newValue = `$${totalUSD.toFixed(2)}`;
    totalBalanceDiv.innerHTML = newValue; // Use innerHTML instead of textContent
    console.log('✅ Updated total balance display to:', newValue);
    console.log('✅ Element now contains:', totalBalanceDiv.innerHTML);
  } else {
    console.error('❌ Total balance div not found with ID: totalBalanceAmount');
  }
  
  if (btcEquivDiv) {
    const newBtcValue = `≈ ${btcEquivalent.toFixed(8)} BTC`;
    btcEquivDiv.innerHTML = newBtcValue; // Use innerHTML instead of textContent
    console.log('✅ Updated BTC equivalent display to:', newBtcValue);
    console.log('✅ Element now contains:', btcEquivDiv.innerHTML);
  } else {
    console.error('❌ BTC equivalent div not found with ID: totalBalanceBTC');
  }
  
  console.log('=== END BALANCE UPDATE ===');
  
  // Return early if no wallets to render
  if (!wallets || wallets.length === 0) {
    container.innerHTML = '<tr><td colspan="5" class="text-center py-8 text-neutral-500">No assets yet</td></tr>';
    if (mobileContainer) {
      mobileContainer.innerHTML = '<div class="text-center py-8 text-neutral-500">No assets yet</div>';
    }
    return;
  }

  // Render assets table (desktop)
  container.innerHTML = wallets.map(wallet => {
    const balance = parseFloat(wallet.balance) || 0;
    const locked = parseFloat(wallet.lockedBalance || wallet.locked_balance) || 0;
    const total = balance + locked;
    const usdValue = calculateUSDValue(wallet.currency, total);
    
    // Get appropriate icon and color for each currency
    let icon = wallet.currency[0];
    let colorClass = 'bg-primary-600';
    let currencyName = wallet.currency;
    
    if (wallet.currency === 'BTC') {
      icon = '₿';
      colorClass = 'bg-orange-500';
      currencyName = 'Bitcoin';
    } else if (wallet.currency === 'ETH') {
      icon = 'Ξ';
      colorClass = 'bg-blue-500';
      currencyName = 'Ethereum';
    } else if (wallet.currency === 'USDT') {
      icon = '₮';
      colorClass = 'bg-green-500';
      currencyName = 'Tether USD';
    }
    
    return `
      <tr class="border-b border-neutral-700">
        <td class="py-4">
          <div class="flex items-center space-x-3">
            <div class="w-10 h-10 ${colorClass} rounded-full flex items-center justify-center text-white font-bold text-lg">
              ${icon}
            </div>
            <div>
              <div class="font-medium">${currencyName}</div>
              <div class="text-xs text-neutral-400">${wallet.currency}</div>
            </div>
          </div>
        </td>
        <td class="font-mono">${total.toFixed(8)}</td>
        <td class="font-mono">${locked.toFixed(8)}</td>
        <td class="font-mono">$${usdValue.toFixed(2)}</td>
        <td>
          <div class="flex space-x-2">
            <button onclick="window.openDepositModal('${wallet.currency}')" class="btn-primary text-xs px-3 py-1">Deposit</button>
            <button onclick="window.openWithdrawModal('${wallet.currency}')" class="btn-secondary text-xs px-3 py-1">Withdraw</button>
          </div>
        </td>
      </tr>
    `;
  }).join('');

  // Render mobile card view
  if (mobileContainer) {
    mobileContainer.innerHTML = wallets.map(wallet => {
      const balance = parseFloat(wallet.balance);
      const locked = parseFloat(wallet.locked_balance);
      const usdValue = calculateUSDValue(wallet.currency, balance);
      
      // Get appropriate icon and color for each currency
      let icon = wallet.currency[0];
      let colorClass = 'bg-primary-600';
      let currencyName = wallet.currency;
      
      if (wallet.currency === 'BTC') {
        icon = '₿';
        colorClass = 'bg-orange-500';
        currencyName = 'Bitcoin';
      } else if (wallet.currency === 'ETH') {
        icon = 'Ξ';
        colorClass = 'bg-blue-500';
        currencyName = 'Ethereum';
      } else if (wallet.currency === 'USDT') {
        icon = '₮';
        colorClass = 'bg-green-500';
        currencyName = 'Tether USD';
      }
      
      return `
        <div class="bg-neutral-700/50 rounded-lg p-4 border border-neutral-600">
          <div class="flex items-center justify-between mb-3">
            <div class="flex items-center space-x-3">
              <div class="w-12 h-12 ${colorClass} rounded-full flex items-center justify-center text-white font-bold text-xl">
                ${icon}
              </div>
              <div>
                <div class="font-medium text-base">${currencyName}</div>
                <div class="text-sm text-neutral-400">${wallet.currency}</div>
              </div>
            </div>
          </div>
          <div class="space-y-2 mb-3">
            <div class="flex justify-between">
              <span class="text-neutral-400 text-sm">Balance:</span>
              <span class="font-mono font-medium">${balance.toFixed(2)} ${wallet.currency}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-neutral-400 text-sm">In Orders:</span>
              <span class="font-mono text-sm">${locked.toFixed(2)} ${wallet.currency}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-neutral-400 text-sm">Value:</span>
              <span class="font-mono font-medium text-regal-gold">$${usdValue.toFixed(2)}</span>
            </div>
          </div>
          <div class="flex gap-2">
            <button onclick="window.openDepositModal('${wallet.currency}')" class="btn-primary flex-1 text-sm py-2">Deposit</button>
            <button onclick="window.openWithdrawModal('${wallet.currency}')" class="btn-secondary flex-1 text-sm py-2">Withdraw</button>
          </div>
        </div>
      `;
    }).join('');
  }
}

async function loadDepositHistory() {
  try {
    const token = localStorage.getItem('token') || localStorage.getItem('authToken');
    if (!token) {
      console.log('No token found for deposit history');
      return;
    }

    console.log('Loading deposit history...');
    const response = await fetch(`${API_URL}/api/v1/auth/deposits`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    console.log('Deposit history response status:', response.status);

    if (!response.ok) {
      console.error('Failed to load deposit history:', response.status);
      return;
    }

    const data = await response.json();
    console.log('Deposit history data:', data);
    
    const depositsList = document.getElementById('depositsList');
    
    if (!data.deposits || data.deposits.length === 0) {
      console.log('No deposits found');
      depositsList.innerHTML = `
        <div class="text-center text-neutral-500 py-8">
          No deposits yet
        </div>
      `;
      return;
    }

    console.log('Rendering', data.deposits.length, 'deposits');
    depositsList.innerHTML = data.deposits.map(deposit => {
      let statusColor = 'text-warning-500';
      let statusBg = 'bg-warning-500/20';
      
      if (deposit.status === 'successful') {
        statusColor = 'text-success-500';
        statusBg = 'bg-success-500/20';
      } else if (deposit.status === 'declined') {
        statusColor = 'text-error-500';
        statusBg = 'bg-error-500/20';
      }
      
      return `
        <div class="p-4 bg-neutral-800 rounded-lg hover:bg-neutral-700 transition-colors">
          <div class="flex justify-between items-start mb-2">
            <div class="flex-1">
              <div class="flex items-center gap-2">
                <span class="font-semibold">${deposit.currency}</span>
                <span class="px-2 py-1 rounded text-xs ${statusBg} ${statusColor} uppercase">${deposit.status}</span>
              </div>
              <div class="text-sm text-neutral-400 mt-1">Amount: ${parseFloat(deposit.amount).toFixed(8)}</div>
            </div>
            <div class="text-right">
              <div class="text-neutral-300 font-mono">${parseFloat(deposit.amount).toFixed(4)} ${deposit.currency}</div>
              <div class="text-xs text-neutral-400">${new Date(deposit.createdAt).toLocaleString()}</div>
            </div>
          </div>
          
          ${deposit.txHash ? `<div class="text-xs text-neutral-400 mt-2 border-t border-neutral-700 pt-2">
            <span class="font-semibold">TX:</span> <span class="font-mono">${deposit.txHash.substring(0, 20)}...</span>
          </div>` : ''}
          
          ${deposit.adminNote ? `<div class="text-sm text-neutral-400 mt-2 border-t border-neutral-700 pt-2">
            <span class="font-semibold">Note:</span> ${deposit.adminNote}
          </div>` : ''}
        </div>
      `;
    }).join('');
  } catch (error) {
    console.error('Error loading deposit history:', error);
  }
}

async function loadWithdrawalHistory() {
  try {
    const token = localStorage.getItem('token') || localStorage.getItem('authToken');
    if (!token) {
      console.log('No token found for withdrawal history');
      return;
    }

    console.log('Loading withdrawal history...');
    const response = await fetch(`${API_URL}/api/v1/auth/withdrawals`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    console.log('Withdrawal history response status:', response.status);

    if (!response.ok) {
      console.error('Failed to load withdrawal history:', response.status);
      return;
    }

    const data = await response.json();
    console.log('Withdrawal history data:', data);
    
    const withdrawalsList = document.getElementById('withdrawalsList');
    
    if (!data.withdrawals || data.withdrawals.length === 0) {
      console.log('No withdrawals found');
      withdrawalsList.innerHTML = `
        <div class="text-center text-neutral-500 py-8">
          No withdrawals yet
        </div>
      `;
      return;
    }

    console.log('Rendering', data.withdrawals.length, 'withdrawals');
    withdrawalsList.innerHTML = data.withdrawals.map(withdrawal => {
      let statusColor = 'text-warning-500';
      let statusBg = 'bg-warning-500/20';
      
      if (withdrawal.status === 'successful') {
        statusColor = 'text-success-500';
        statusBg = 'bg-success-500/20';
      } else if (withdrawal.status === 'declined') {
        statusColor = 'text-error-500';
        statusBg = 'bg-error-500/20';
      }
      
      const totalAmount = parseFloat(withdrawal.amount) + parseFloat(withdrawal.fee || 0);
      
      return `
        <div class="p-4 bg-neutral-800 rounded-lg hover:bg-neutral-700 transition-colors">
          <div class="flex justify-between items-start mb-2">
            <div class="flex-1">
              <div class="flex items-center gap-2">
                <span class="font-semibold">${withdrawal.currency}</span>
                <span class="px-2 py-1 rounded text-xs ${statusBg} ${statusColor} uppercase">${withdrawal.status}</span>
              </div>
              <div class="text-sm text-neutral-400 mt-1">Amount: ${parseFloat(withdrawal.amount).toFixed(8)}</div>
              ${withdrawal.fee ? `<div class="text-sm text-neutral-400">Fee: ${parseFloat(withdrawal.fee).toFixed(8)}</div>` : ''}
            </div>
            <div class="text-right">
              <div class="text-neutral-300 font-mono">${parseFloat(withdrawal.amount).toFixed(4)} ${withdrawal.currency}</div>
              <div class="text-xs text-neutral-400">${new Date(withdrawal.createdAt).toLocaleString()}</div>
            </div>
          </div>
          
          ${withdrawal.destinationAddress ? `<div class="text-xs text-neutral-400 mt-2 border-t border-neutral-700 pt-2">
            <span class="font-semibold">To:</span> <span class="font-mono">${withdrawal.destinationAddress.substring(0, 20)}...</span>
          </div>` : ''}
          
          ${withdrawal.txHash ? `<div class="text-xs text-neutral-400 mt-1">
            <span class="font-semibold">TX:</span> <span class="font-mono">${withdrawal.txHash.substring(0, 20)}...</span>
          </div>` : ''}
        </div>
      `;
    }).join('');
  } catch (error) {
    console.error('Error loading withdrawal history:', error);
  }
}

async function loadTradeHistory() {
  try {
    const token = localStorage.getItem('token') || localStorage.getItem('authToken');
    if (!token) {
      console.log('No token found for trade history');
      return;
    }

    console.log('Loading trade history...');
    const response = await fetch(`${API_URL}/api/v1/auth/user-trades`, {
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    });

    console.log('Trade history response status:', response.status);

    if (!response.ok) {
      console.error('Failed to load trade history:', response.status);
      return;
    }

    const data = await response.json();
    console.log('Trade history data:', data);
    
    const tradesList = document.getElementById('tradesList');
    
    if (!data.trades || data.trades.length === 0) {
      console.log('No trades found');
      tradesList.innerHTML = `
        <div class="text-center text-neutral-500 py-8">
          No trades yet
        </div>
      `;
      return;
    }

    console.log('Rendering', data.trades.length, 'trades');
    tradesList.innerHTML = data.trades.map(trade => {
      const isProfitable = parseFloat(trade.profit_loss) >= 0;
      const statusColor = isProfitable ? 'text-success-500' : 'text-error-500';
      const statusIcon = isProfitable ? '↑' : '↓';
      
      return `
        <div class="p-4 bg-neutral-800 rounded-lg hover:bg-neutral-700 transition-colors">
          <div class="flex justify-between items-start mb-2">
            <div class="flex-1">
              <div class="flex items-center gap-2">
                <span class="font-semibold">${trade.pair}</span>
                <span class="px-2 py-1 rounded text-xs ${trade.trade_type === 'BUY' ? 'bg-success-500/20 text-success-500' : 'bg-error-500/20 text-error-500'}">${trade.trade_type}</span>
              </div>
              <div class="text-sm text-neutral-400 mt-1">Capital: ${trade.capital}</div>
            </div>
            <div class="text-right">
              <div class="${statusColor} font-bold flex items-center gap-1">
                ${statusIcon} ${parseFloat(trade.profit_loss).toFixed(2)} ${trade.capital}
              </div>
              <div class="text-xs text-neutral-400">${isProfitable ? 'Profit' : 'Loss'}</div>
            </div>
          </div>
          
          <div class="flex justify-between items-center text-sm">
            <div class="text-neutral-400">
              Amount: <span class="font-mono text-neutral-300">${parseFloat(trade.amount).toFixed(4)}</span>
            </div>
            <div class="text-neutral-400">
              ${new Date(trade.created_at).toLocaleString()}
            </div>
          </div>
          
          ${trade.notes ? `<div class="text-sm text-neutral-400 mt-2 border-t border-neutral-700 pt-2">${trade.notes}</div>` : ''}
        </div>
      `;
    }).join('');
  } catch (error) {
    console.error('Error loading trade history:', error);
  }
}

// Make functions available globally
window.loadTradeHistory = loadTradeHistory;

export { loadWallets };
